import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { OrganizationDetail, PublicUserProfile } from '@spi/shared';

export function useOrganization(id: number) {
  return useQuery({
    queryKey: ['organizations', id],
    queryFn: () => apiFetch<OrganizationDetail>(`/api/organizations/${id}`),
    enabled: id > 0,
  });
}

export function usePublicUser(id: number) {
  return useQuery({
    queryKey: ['users', 'public', id],
    queryFn: () => apiFetch<PublicUserProfile>(`/api/users/${id}/public`),
    enabled: id > 0,
  });
}
